var commaSeparateRemove = function(val){
    val = parseFloat(val.replace(/,/g, ""));
    return val;
};

var commaSeparateNumber = function(val){
    while (/(\d+)(\d{3})/.test(val.toString())){
      val = val.toString().replace(/(\d+)(\d{3})/, '$1'+','+'$2');
    }
    return val;
}; 

var responsiveTable = function($tableWrapper, $table){
    var tableWrapperWidth = $tableWrapper.width();
    var tableWidth = $table.width();
    if(tableWidth > tableWrapperWidth){
        $tableWrapper.addClass('scroll');
    } else{
        $tableWrapper.removeClass('scroll');
    }
};

var is_touch_device = function() {
    return ('ontouchstart' in window ||
    window.DocumentTouch && document instanceof DocumentTouch ||
    navigator.maxTouchPoints > 0 ||
    navigator.msMaxTouchPoints > 0);
};


// with mast plugin
//$('.money').mask("#,##0", {reverse: true});
